import { Box, Card, CardHeader, CardBody, Heading, Text } from '@chakra-ui/react'
import { useParams } from 'react-router-dom'
import { useNavigateToList } from '@/hooks/useNavigateToList'
import { AdminLayout } from '@/components/layout/AdminLayout'
import { BudgetManagementForm } from '@/components/forms/BudgetManagementForm'
import { useThemeColors } from '@/hooks/useThemeColors'

export default function EditBudgetManagementPage() {
  const colors = useThemeColors()
  const navigateToList = useNavigateToList('/budget-management')

  const { expenseType, sourceId: sourceIdParam } = useParams<{ expenseType: string; sourceId: string }>()
  /** Backend source entity id (summary row `source_id`), not the budget summary row `id`. */
  const numericId = sourceIdParam ? Number(sourceIdParam) : undefined

  // Convert kebab-case URL format to title case for form
  const convertExpenseTypeFormat = (type: string): string => {
    const typeMap: Record<string, string> = {
      'issued-budget': 'Issued Budget',
      'truck-expense': 'Truck Expense',
      'parts-expense': 'Parts Expense',
      'other-expense': 'Other Expense',
      'driver-cash-advance': 'Driver Cash Advance',
      'helper-cash-advance': 'Helper Cash Advance',
    }
    return typeMap[type.toLowerCase()] || type
  }

  const formattedExpenseType = expenseType ? convertExpenseTypeFormat(expenseType) : undefined

  const handleSuccess = () => {
    navigateToList()
  }

  const handleCancel = () => {
    navigateToList()
  }

  return (
    <AdminLayout>
      <Box p={4} h="100%" overflow="auto">
        <Card>
          <CardHeader>
            <Heading size="md" mb={1}>
              Edit Budget Record
            </Heading>
            <Text fontSize="sm" color={colors.text}>
              Update Budget Record details
            </Text>
          </CardHeader>
          <CardBody>
            <BudgetManagementForm 
              budgetManagementId={numericId} 
              budgetManagementExpenseType={formattedExpenseType} 
              onSuccess={handleSuccess} 
              onCancel={handleCancel}
              />
          </CardBody>
        </Card>
      </Box>
    </AdminLayout>
  )
}
